import React from "react";
import { Container } from "react-bootstrap";

const Heading = () => {
  return (
    <>
      <section className="first-webDevelopment-section">
        <Container>
          <div className="page-title text-center">
            <h1>Blog</h1>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Heading;
